module.exports = __webpack_public_path__ + "static/media/black-grey-pattern.294b2918.jpg";